export default __webpack_public_path__ + "static/media/steak_taco.3b645fdd.mp3";